module.exports = __webpack_public_path__ + "assets/img/a2e6-ma.svg";